import React, { Component, Fragment } from 'react';
import DDadosItem from '@common/components/ddados/ddados.item';
import autoBind from 'react-autobind';
import { Row, Col } from 'react-bootstrap';
import Button from '@material-ui/core/Button';

class CampoDinamicoAnexo extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      anexo: [],
      anexoCustomizado: [],
    };
  }

  static getDerivedStateFromProps(props, currentState) {
    const { state } = props;

    if (state) {
      if (JSON.stringify(state) != JSON.stringify(currentState)) {
        return { ...state };
      }
    }
    return null;
  }

  callPropsChange(value) {
    const { onChange } = this.props;
    const returnValue = value || this.state;

    onChange && onChange(returnValue);
  }

  onChangeAnexo(index, newAnexo) {
    const { anexo } = this.state;

    let anexoArray = this.handleChange(anexo, index, newAnexo);

    let newState = { ...this.state, anexo: anexoArray };

    this.setState({ newState });

    this.callPropsChange(anexoArray);
  }

  onChangeAnexoCustomizado(index, newAnexo) {
    const { anexoCustomizado } = this.state;

    let anexoArray = this.handleChange(anexoCustomizado, index, newAnexo);

    let newState = { ...this.state, anexoCustomizado: anexoArray };

    this.setState({ newState });

    this.callPropsChange(anexoArray);
  }

  handleChange(array, index, newAnexo) {
    let anexoArray = [...array];

    let anexoObjeto = {
      ...array[index],
      NomeArquivo: newAnexo ? newAnexo.name : null,
      Valor: newAnexo,
      isUpdate: !!array[index].Caminho && !!newAnexo,
    };

    anexoArray[index] = anexoObjeto;

    return anexoArray;
  }

  addAnexoCustomizado() {
    const { anexoCustomizado } = this.state;

    let anexoArray = [...anexoCustomizado];

    let anexoObjeto = { ...anexoArray[0] };

    let newAnexoCustomizado = {
      ...anexoObjeto,
      Id: undefined,
      Valor: undefined,
      Descricao: undefined,
      NomeArquivo: undefined,
      Caminho: undefined,
    };

    let newAnexoArray = [...anexoArray, newAnexoCustomizado];

    let newState = { ...this.state, anexoCustomizado: newAnexoArray };

    this.setState({ newState });

    this.callPropsChange(newAnexoArray);
  }

  onDelete(index) {
    const { anexoCustomizado } = this.state;

    let anexoArray = [...anexoCustomizado];

    let newAnexoArray = anexoArray.filter((_anexo, _index) => _index != index);

    let newState = { ...this.state, anexoCustomizado: newAnexoArray };

    this.setState({ newState });

    this.callPropsChange(newAnexoArray);
  }

  onChangeText(text, index) {
    const { anexoCustomizado } = this.state;

    let anexoArray = [...anexoCustomizado];

    let newObjeto = { ...anexoArray[index], Descricao: text };

    anexoArray[index] = newObjeto;

    let newState = { ...this.state, anexoCustomizado: anexoArray };

    this.setState({ newState });

    this.callPropsChange(anexoArray);
  }

  renderTipoCustomizado() {
    const {
      isView,
      prefix,
      service,
      isExterno,
      extensionsAllowed,
      TamanhoNomeArquivo,
      desabilitaCamposObrigatorios,
    } = this.props;

    const { anexoCustomizado: arrayAnexoCustomizado } = this.state;

    return (
      <Fragment>
        {arrayAnexoCustomizado.map(
          (anexoCustomizado, index) =>
            !anexoCustomizado.isDeleteFromScreen && (
              <Fragment key={index}>
                <Row>
                  <Col lg={3}>
                    <DDadosItem
                      state={anexoCustomizado}
                      stateName="Descricao"
                      name={anexoCustomizado.TipoAnexo.DDados.Name}
                      Label={anexoCustomizado.TipoAnexo.DDados.Label}
                      Titulo={anexoCustomizado.TipoAnexo.DDados.Titulo}
                      Tooltip={anexoCustomizado.TipoAnexo.DDados.Tooltip}
                      Tipo={'text'}
                      Obrigatorio={
                        anexoCustomizado.TipoAnexo.DDados.Obrigatorio && !isView && !desabilitaCamposObrigatorios
                      }
                      isView={isView}
                      disabled={isView}
                      onBlur={(text) => this.onChangeText(text, index)}
                      prefix={prefix}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <DDadosItem
                      state={anexoCustomizado}
                      stateName="Valor"
                      name={anexoCustomizado.TipoAnexo.DDados.Name}
                      Label={anexoCustomizado.TipoAnexo.DDados.Label}
                      Titulo={anexoCustomizado.TipoAnexo.DDados.Titulo}
                      Tooltip={anexoCustomizado.TipoAnexo.DDados.Tooltip}
                      service={service}
                      Tipo={'file'}
                      Obrigatorio={
                        anexoCustomizado.TipoAnexo.DDados.Obrigatorio && !isView && !desabilitaCamposObrigatorios
                      }
                      TipoFileUpload={'file'}
                      TamanhoNomeArquivo={TamanhoNomeArquivo}
                      disabled={isView}
                      prefix={prefix}
                      Caminho={anexoCustomizado.Caminho}
                      extensionsAllowed={extensionsAllowed}
                      onChange={(anexo) => this.onChangeAnexoCustomizado(index, anexo)}
                      onDelete={index == 0 ? false : () => this.onDelete(index)}
                    />
                  </Col>
                </Row>
              </Fragment>
            )
        )}
        <Row>
          <Col>
            {!isExterno && (
              <button
                type="button"
                onClick={() => this.addAnexoCustomizado()}
                className="btn btn-primary d-inline mt-4"
                disabled={isView}
              >
                <i className="fas fa-plus ml-2" /> Adicionar Novo
              </button>
            )}
            {isExterno && (
              <Button
                variant="contained"
                color="primary"
                className={'mt-2'}
                onClick={() => this.addAnexoCustomizado()}
                disabled={isView}
              >
                Adicionar Novo
                <i className={'fas fa-plus ml-2'}></i>
              </Button>
            )}
          </Col>
        </Row>
      </Fragment>
    );
  }

  renderTipoNaoCustomizado() {
    const { isView, prefix, service, extensionsAllowed, TamanhoNomeArquivo, desabilitaCamposObrigatorios } = this.props;

    const { anexo: arrayAnexo } = this.state;

    return (
      <Fragment>
        {arrayAnexo.map((anexo, index) => (
          <Fragment key={index}>
            <Row>
              <Col lg={6}>
                <DDadosItem
                  state={anexo}
                  stateName="Valor"
                  name={anexo.TipoAnexo.DDados.Name}
                  Label={anexo.TipoAnexo.DDados.Label}
                  Titulo={anexo.TipoAnexo.DDados.Titulo}
                  Tooltip={anexo.TipoAnexo.DDados.Tooltip}
                  service={service}
                  Tipo={'file'}
                  TipoFileUpload={'file'}
                  Obrigatorio={anexo.TipoAnexo.DDados.Obrigatorio && !isView && !desabilitaCamposObrigatorios}
                  disabled={isView}
                  TamanhoNomeArquivo={TamanhoNomeArquivo}
                  prefix={prefix}
                  Caminho={anexo.Caminho}
                  extensionsAllowed={extensionsAllowed}
                  onChange={(anexo) => this.onChangeAnexo(index, anexo)}
                />
              </Col>
            </Row>
          </Fragment>
        ))}
      </Fragment>
    );
  }

  render() {
    const { TipoCustomizado } = this.props;
    const { anexo, anexoCustomizado } = this.state;

    return (
      <Fragment>
        {!TipoCustomizado && anexo && anexo.length > 0 && this.renderTipoNaoCustomizado()}
        {TipoCustomizado && anexoCustomizado && anexoCustomizado.length > 0 && this.renderTipoCustomizado()}
      </Fragment>
    );
  }
}

export default CampoDinamicoAnexo;
